// 个人信息管理
<template>
    <div class="group maininfo">
        <el-row :gutter="20">
            <!-- 左侧：个人信息 -->
            <el-col :span="12">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <i class="el-icon-edit"></i>
                        <span>个人信息</span>
                    </div>
                    <div class="search-content mar_b">
                        <el-form :inline="true" label-width="100px" size="medium" :model="userInfo" class="demo-form-inline" ref="userInfo">
                            <el-form-item prop="name" label="" style="margin-top:10px;margin-bottom:10px;">
                                <span>您好：{{ userInfo.name }},欢迎登陆!</span>
                            </el-form-item><br>
                            <el-form-item prop="realname" label="真实姓名：" style="margin-top:10px;margin-bottom:10px;">
                                <span>{{ userInfo.realname }}</span>
                            </el-form-item>
                            <el-form-item prop="count" label="登录次数：" style="margin-top:10px;margin-bottom:10px;">
                                <span>{{ userInfo.count }}</span>
                            </el-form-item><br>
                            <!--
                            <el-form-item prop="type" label="用户身份：" style="margin-top:10px;margin-bottom:10px;">
                                <span>{{ userInfo.type }}</span>
                            </el-form-item><br>
                            -->
                            <el-form-item prop="createtime" label="加入时间：" style="margin-top:10px;margin-bottom:10px;">
                                <span>{{ userInfo.createtime }}</span>
                            </el-form-item><br>
                            
                            <el-form-item prop="op_time" label="上次登陆：" style="margin-top:10px;margin-bottom:10px;">
                                <span>{{ userInfo.op_time }}</span>&nbsp;&nbsp;&nbsp;
                                <span>{{ userInfo.loginip }}</span>
                            </el-form-item><br>
                            <!-- 新增：重要日期提醒 -->
                            <el-form-item prop="dateReminders" label="重要日期：" style="margin-top:10px;margin-bottom:10px;">
                                <div style="color: teal; white-space: pre-line; line-height: 2; text-align: left;" v-html="allMessages"></div>
                            </el-form-item><br>
                        </el-form>
                    </div>
                </el-card>
            </el-col>
            <!-- 右侧：客户价格列表 -->
            <el-col :span="12">
                <el-card class="box-card right-card">
                    <div slot="header" class="clearfix">
                        <i class="el-icon-price-tag"></i>
                        <span>客户货品信息</span>
                    </div>
                    <div class="search-content mar_b right-content">
                        <div v-if="clientPriceList && clientPriceList.length > 0">
                            <div 
                                v-for="(item, index) in clientPriceList" 
                                :key="index" 
                                style="padding: 10px 0; border-bottom: 1px solid #ebeef5; line-height: 1.8;"
                            >
                                <div style="margin-bottom: 5px;">
                                    <span style="font-weight: bold;">{{ item.remark || '无' }}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                                    <span style="font-weight: bold; color: #409EFF;">持有货品价值：</span>
                                    <span :style="{ fontWeight: 'bold', color: (item.sale_price >= 200000 ? 'red' : 'black') }">￥{{ item.sale_price }}</span>
                                </div>
                                
                            </div>
                        </div>
                        <div v-else style="text-align: center; padding: 40px 0; color: #909399;">
                            暂无数据
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import util from '../../common/js/util';
    const Base64 = require('js-base64').Base64;
    import calendar from 'js-calendar-converter';
    export default {
        data() {
            return {
                // 查询
                query: {
                    clzt: '',
                    khmc: '',
                    data_dt: []
                },
                // 用户信息
                userInfo: {
                    name: '',
                    type: '',
                    role: '',
                    dept: '',
                    count: '',
                    realname: '',
                    createtime: '',
                    op_time: '',
                    loginip: '',
                },
                // 分页
                pager: {
                    page: 1,
                    rows: 10,
                    total: 0
                },
                // 新增：重要日期信息
                allMessages: '',
                // 客户价格列表
                clientPriceList: []
            };
        },
        methods: {
            // 选择行数
            sizeChange(rows) {
                this.pager.rows = rows;
                //this.getUserInfoAllList();
            },
            // 选择页
            pageChange(page) {
                this.pager.page = page;
                //this.getUserInfoAllList();
            },
            // 获取个人信息列表
            getUserInfoByCondition() {
                let _this = this;
                util.publicget('/user/getUserInfoByCondition2', {
                    username: sessionStorage.getItem('userName')
                }, function (res) {
                    if (res.flag) {
                        _this.userInfo.name = res.userName;
                        _this.userInfo.realname = res.realname;
                        if(res.userType === 0){
                            _this.userInfo.type = '员工';
                        }else if(res.userType === 1 || res.userType === 2){
                            _this.userInfo.type = '管理';
                        }else if(res.userType === 3){
                            _this.userInfo.type = '超级管理';
                        }else if(res.userType === 4){
                            _this.userInfo.type = '销售客户';
                        }
                        _this.userInfo.createtime = res.createtime;
                        _this.userInfo.count = res.countTotal;
                        _this.userInfo.op_time = res.op_time;
                        _this.userInfo.loginip = res.loginip;
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 获取钻石检索的各个客户货物价值
            selectListClientPrice() {
                let _this = this;
                let remark = '尔恒,李贵妃,海晶,ECO,ECO成品,宝钻荟,克拉花园,美时美钻,娜娜,小冉,ZD';
                util.publicget('/diamond/selectListClientPrice', {
                    remark: remark
                }, function (res) {
                    if (res.flag) {
                        // console.log(res.obj);
                        _this.clientPriceList = res.obj || [];
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 时间确定按钮
            onChangeDate(val) {
                if (val) {
                    let that = this;
                    that.query.data_dt = [this.getControlTimeTo(val[0]), this.getControlTimeTo(val[1])];
                }
            },
            
            // 新的通知函数，使用js-calendar-converter库
            apenPage() {
                const h = this.$createElement;
                
                // 周年 幻想 老板 忠诚 晓丹 集雯 志鸿 俊哥 晓婷
                var content_list = ['8月1日','8月18日','12月8日','7月3日','农历1月15日','12月18日','5月17日','8月25日','1月3日'];
                //var content_list = ['农历7月1日'];
                const now = new Date();
                
                // 解析日期列表并计算距离当前日期的天数
                let closestDate = null;
                let minDaysDiff = Infinity;
                let targetSolarDate = null;
                
                content_list.forEach(dateStr => {
                    let targetDate;
                    
                    // 检查是否为农历日期
                    const lunarMatch = dateStr.match(/农历(\d+)月(\d+)日/);
                    if (lunarMatch) {
                        const lunarMonth = parseInt(lunarMatch[1]);
                        const lunarDay = parseInt(lunarMatch[2]);

                        // 计算今年的农历对应阳历日期
                        let yangli = calendar.lunar2solar(now.getFullYear(), lunarMonth, lunarDay, false);
                        console.log(yangli)
                        targetDate = new Date(yangli.cYear, yangli.cMonth-1, yangli.cDay)
                        
                        // 如果目标日期已经过了，计算明年的日期
                        if (targetDate && targetDate < now) {
                            let yangli = calendar.lunar2solar(now.getFullYear()+1, lunarMonth, lunarDay, false);
                            console.log(yangli)
                            targetDate = new Date(yangli.cYear, yangli.cMonth-1, yangli.cDay)
                        }
                        
                    } else {
                        // 解析阳历日期字符串（格式：'8月1日'）
                        const match = dateStr.match(/(\d+)月(\d+)日/);
                        if (match) {
                            const month = parseInt(match[1]);
                            const day = parseInt(match[2]);
                            
                            // 创建今年的日期对象
                            targetDate = new Date(now.getFullYear(), month - 1, day);
                            
                            // 如果目标日期已经过了，计算明年的日期
                            if (targetDate < now) {
                                targetDate.setFullYear(now.getFullYear() + 1);
                            }
                        }
                    }
                    
                    if (targetDate) {
                        // 计算天数差
                        const timeDiff = targetDate.getTime() - now.getTime();
                        const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
                        
                        // 更新最近的日期
                        if (daysDiff < minDaysDiff) {
                            minDaysDiff = daysDiff;
                            closestDate = dateStr;
                            targetSolarDate = targetDate;
                        }
                    }
                });
                
                // 构建消息
                let message = '';
                if (closestDate) {
                    // 格式化目标阳历日期
                    const formatDate = (date) => {
                        if (!date) return '';
                        const year = date.getFullYear();
                        const month = String(date.getMonth() + 1).padStart(2, '0');
                        const day = String(date.getDate()).padStart(2, '0');
                        return `${year}年${month}月${day}日`;
                    };
                    
                    const solarDateStr = formatDate(targetSolarDate);
                    
                    if(closestDate == '8月1日'){
                        message = `公司周年日：${closestDate} (${solarDateStr}),还有${minDaysDiff}天`;
                    }else if(closestDate == '12月8日'){
                        message = `老板诞辰：${closestDate} (${solarDateStr}),还有${minDaysDiff}天`;
                    }else if(closestDate == '8月18日'){
                        message = `幻想诞辰：${closestDate} (${solarDateStr}),还有${minDaysDiff}天`;
                    }else if(closestDate == '12月18日'){
                        message = `集雯诞辰：${closestDate} (${solarDateStr}),还有${minDaysDiff}天`;
                    }else if(closestDate == '8月25日'){
                        message = `俊哥诞辰：${closestDate} (${solarDateStr}),还有${minDaysDiff}天`;
                    }else if(closestDate == '农历1月15日'){
                        message = `晓丹诞辰：${closestDate} (${solarDateStr}),还有${minDaysDiff}天`;
                    }else if(closestDate == '5月17日'){
                        message = `志鸿诞辰：${closestDate} (${solarDateStr}),还有${minDaysDiff}天`;
                    }else if(closestDate == '1月3日'){
                        message = `晓婷诞辰：${closestDate} (${solarDateStr}),还有${minDaysDiff}天`;
                    }else if(closestDate == '7月3日'){
                        message = `忠诚诞辰：${closestDate} (${solarDateStr}),还有${minDaysDiff}天`;
                    }else{
                        message = `最近的日期：${closestDate} (${solarDateStr})（还有${minDaysDiff}天）`;
                    }
                } else {
                    message = '公司周年日：8月1日';
                }
                
                this.$notify({
                    title: '系统通知',
                    message: h('i', { style: 'color: teal'}, message)
                });
            },

            apenPage2() {
                const h = this.$createElement;
                
                // 周年 幻想 老板 忠诚 晓丹 集雯 志鸿 俊哥 晓婷
                var content_list = ['8月1日','8月18日','12月8日','7月3日','农历1月15日','12月18日','5月17日','8月25日','1月3日'];
                const now = new Date();
                
                // 存储所有日期信息
                let allDateInfo = [];
                
                // 检查两个日期是否是同一天的函数
                const isSameDay = (date1, date2) => {
                    return date1.getFullYear() === date2.getFullYear() &&
                        date1.getMonth() === date2.getMonth() &&
                        date1.getDate() === date2.getDate();
                };
                
                content_list.forEach(dateStr => {
                    let targetDate;
                    
                    // 检查是否为农历日期
                    const lunarMatch = dateStr.match(/农历(\d+)月(\d+)日/);
                    if (lunarMatch) {
                        const lunarMonth = parseInt(lunarMatch[1]);
                        const lunarDay = parseInt(lunarMatch[2]);

                        // 计算今年的农历对应阳历日期
                        let yangli = calendar.lunar2solar(now.getFullYear(), lunarMonth, lunarDay, false);
                        targetDate = new Date(yangli.cYear, yangli.cMonth-1, yangli.cDay)
                        
                        // 如果目标日期已经过了，计算明年的日期
                        if (targetDate && targetDate < now && !isSameDay(targetDate, now)) {
                            let yangli = calendar.lunar2solar(now.getFullYear()+1, lunarMonth, lunarDay, false);
                            targetDate = new Date(yangli.cYear, yangli.cMonth-1, yangli.cDay)
                        }
                        
                    } else {
                        // 解析阳历日期字符串（格式：'8月1日'）
                        const match = dateStr.match(/(\d+)月(\d+)日/);
                        if (match) {
                            const month = parseInt(match[1]);
                            const day = parseInt(match[2]);
                            
                            // 创建今年的日期对象
                            targetDate = new Date(now.getFullYear(), month - 1, day);
                            
                            // 如果目标日期已经过了且不是同一天，计算明年的日期
                            if (targetDate < now && !isSameDay(targetDate, now)) {
                                targetDate.setFullYear(now.getFullYear() + 1);
                            }
                        }
                    }
                    
                    if (targetDate) {
                        // 计算天数差
                        const timeDiff = targetDate.getTime() - now.getTime();
                        const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
                        
                        // 格式化目标阳历日期
                        const formatDate = (date) => {
                            if (!date) return '';
                            const year = date.getFullYear();
                            const month = String(date.getMonth() + 1).padStart(2, '0');
                            const day = String(date.getDate()).padStart(2, '0');
                            return `${year}年${month}月${day}日`;
                        };
                        
                        const solarDateStr = formatDate(targetDate);
                        
                        // 根据日期确定对应的名称
                        let name = '';
                        if(dateStr == '8月1日'){
                            name = '公司周年日';
                        }else if(dateStr == '12月8日'){
                            name = '老板诞辰';
                        }else if(dateStr == '8月18日'){
                            name = '幻想诞辰';
                        }else if(dateStr == '12月18日'){
                            name = '集雯诞辰';
                        }else if(dateStr == '8月25日'){
                            name = '俊哥诞辰';
                        }else if(dateStr == '农历1月15日'){
                            name = '晓丹诞辰';
                        }else if(dateStr == '5月17日'){
                            name = '志鸿诞辰';
                        }else if(dateStr == '1月3日'){
                            name = '晓婷诞辰';
                        }else if(dateStr == '7月3日'){
                            name = '忠诚诞辰';
                        }
                        
                        allDateInfo.push({
                            name: name,
                            originalDate: dateStr,
                            solarDate: solarDateStr,
                            daysDiff: daysDiff
                        });
                    }
                });
                
                // 按天数排序，最近的在前
                allDateInfo.sort((a, b) => a.daysDiff - b.daysDiff);
                
                // 构建所有日期的消息
                let allMessages = allDateInfo.map((info, index) => {
                    if (index === 0) {
                        if (info.daysDiff < 1) {
                            return `<span style="color: #FF6B35; font-weight: bold;">${info.originalDate}  (${info.solarDate})，今天是${info.name}!</span>`;
                        } else {
                            return `${info.name}：${info.originalDate}  (${info.solarDate})，还有<span style="color: #FF6B35; font-weight: bold;"> ${info.daysDiff} </span>天`;
                        }
                        return `${info.name}：${info.originalDate}  (${info.solarDate})，还有<span style="color: #FF6B35; font-weight: bold;"> ${info.daysDiff} </span>天`;
                    } else {
                        return `${info.name}：${info.originalDate}  (${info.solarDate})，还有 ${info.daysDiff} 天`;
                    }
                    //return `${info.name}：${info.originalDate} (${info.solarDate})，还有${info.daysDiff}天`;
                }).join('\n');
                
                // 如果没有找到任何日期信息
                if (allDateInfo.length === 0) {
                    allMessages = '暂无日期信息';
                }
                
                // 将结果赋值给 data 中的 allMessages
                this.allMessages = allMessages;
                /*
                this.$notify({
                    title: '所有重要日期提醒',
                    message: h('div', { 
                        style: 'color: teal; white-space: pre-line; line-height: 2;'
                    }, allMessages),
                    duration: 8000, // 显示8秒
                    type: 'info'
                });
                */
            },
        },
        mounted() {
            this.getUserInfoByCondition();
            this.apenPage2();
            this.selectListClientPrice();
        }
    };
</script>

<style lang="scss">
    // 确保左右卡片高度一致
    .maininfo {
        .el-row {
            display: flex;
            align-items: stretch;
        }
        .el-col {
            display: flex;
            flex-direction: column;
        }
        .box-card {
            display: flex;
            flex-direction: column;
            height:100%;
        }
        .right-card {
            .el-card__body {
                display: flex;
                flex-direction: column;
                flex: 1;
                padding: 20px;
            }
        }
        .right-content {
            flex: 1;
            overflow-y: auto;
            max-height: calc(100vh - 200px);
        }
    }

/**手机屏幕展示 */
    @media screen and (max-width: 748px){
        .mainds {
            position: relative;
            float: left;
            height: 500px;
        }
        .mainds {
            font-size: 12px;
            font-weight: bold;
            color: #04375f;
            -webkit-transform-origin-x: 0; // 文字居左
            -webkit-transform: scale(0.71);
            transform: scale(0.71);
            transform-origin: left top;
        }
        /**奇偶行变色 */
        .el-table__row--striped td {
            background-color: #eaf3fb !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/pzxx/personalInfo.vue